import React from "react";
import { fontsName } from "../../assets/fonts/fontsName";
import details1 from "../../assets/images/projects/projects-details1.jpg";
import SidebarAbout from "./SidebarAbout";
import { request, gql } from "graphql-request";
import { REQUEST_URL } from "../RequestUrl";

const MAIN_INFO_ABOUT = gql`
  {
    getWebsiteAboutUs {
      _id
      pictureLink
      description
      schoolName
      title
    }
  }
`;

const MainAbout = () => {
  const [aboutUsInfo, setAboutUsInfo] = React.useState({});

  React.useEffect(() => {
    request(REQUEST_URL, MAIN_INFO_ABOUT).then((data) => {
      setAboutUsInfo(data.getWebsiteAboutUs);
    });
  }, []);

  return (
    <section className="case-studies-details-area ptb-100">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-12">
            {aboutUsInfo && aboutUsInfo.pictureLink !== null && (
              <div className="case-studies-details-image">
                <img src={aboutUsInfo && aboutUsInfo.pictureLink} alt="about" />
              </div>
            )}

            <div className="case-studies-details-desc" dir="rtl">
              {/* <span className="sub-title">Data Science</span> */}
              <h3
                style={{ fontFamily: fontsName.BNazanin, textAlign: "justify" }}
              >
                {/* لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با
                استفاده از طراحان گرافیک است */}
                {aboutUsInfo && aboutUsInfo.title}
              </h3>
              <p
                style={{ fontFamily: fontsName.BNazanin, textAlign: "justify" }}
              >
                {/* لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با
                استفاده از طراحان گرافیک است، چاپگرها و متون بلکه روزنامه و مجله
                در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی تکنولوژی مورد
                نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد،
                کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان
                جامعه و متخصصان را می طلبد، تا با نرم افزارها شناخت بیشتری را
                برای طراحان رایانه ای علی الخصوص طراحان خلاقی، و فرهنگ پیشرو در
                زبان فارسی ایجاد کرد، در این صورت می توان امید داشت که تمام و
                دشواری موجود در ارائه راهکارها، و شرایط سخت تایپ به پایان رسد و
                زمان مورد نیاز شامل حروفچینی دستاوردهای اصلی، و جوابگوی سوالات
                پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد. */}
                {aboutUsInfo && aboutUsInfo.description}
              </p>
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <SidebarAbout aboutUsInfo={aboutUsInfo} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MainAbout;
